import { useEffect, useRef, useState } from 'react';
import { toast } from 'sonner';
import { useAuth } from '../../context/AuthContext';

export const useFidemSpeaker = (conversation) => {
  const { api } = useAuth();
  const [playing, setPlaying] = useState(null), [loading, setLoading] = useState(null);
  const audio = useRef(null), url = useRef(null), request = useRef(null), epoch = useRef(0);
  const release = () => { if (audio.current) { audio.current.onended = null; audio.current.onerror = null; audio.current.pause(); audio.current.src = ''; } audio.current = null; if (url.current) URL.revokeObjectURL(url.current); url.current = null; };
  const stop = () => { epoch.current += 1; request.current?.abort(); release(); setPlaying(null); setLoading(null); };
  useEffect(() => { stop(); return () => { epoch.current += 1; request.current?.abort(); release(); }; }, [conversation]); // eslint-disable-line react-hooks/exhaustive-deps
  const listen = async (id, text) => {
    if (playing === id || loading === id) { stop(); return; }
    stop(); const version = epoch.current;
    const clean = text.replace(/\[([^\]]+)\]\([^)]+\)/g, '$1').replace(/[*_#`>]+/g, '');
    const chunks = clean.match(/[\s\S]{1,3800}/g) || [];
    const next = async index => {
      if (version !== epoch.current) return;
      if (index >= chunks.length) { stop(); return; }
      setLoading(id); setPlaying(null);
      try {
        request.current = new AbortController();
        const { data } = await api.post('/voice-ai/tts', { text: chunks[index] }, { responseType: 'blob', signal: request.current.signal, timeout: 90000 });
        if (version !== epoch.current) return;
        release(); url.current = URL.createObjectURL(data); const player = new Audio(url.current); audio.current = player;
        player.onended = () => { release(); next(index + 1); };
        player.onerror = () => { if (version === epoch.current) { stop(); toast.error('No se pudo reproducir la voz.'); } };
        await player.play(); if (version === epoch.current) { setLoading(null); setPlaying(id); }
      } catch (e) { if (version === epoch.current && e.code !== 'ERR_CANCELED') { stop(); toast.error('No se pudo reproducir la voz. Intenta nuevamente.'); } }
    };
    await next(0);
  };
  return { listen, stop, playing, loading };
};